export * from './CookiesConsent';
export * from './didomi.service';
export * from './didomi.types';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/cookies-consent/index.ts